module.exports = __webpack_public_path__ + "img/icon-trends.ac3b0a1b.png";